"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackSocialAuthenticateEmailTaken = trackSocialAuthenticateEmailTaken;
exports.trackSocialButtonClick = trackSocialButtonClick;
exports.trackSocialCreateCreateClick = trackSocialCreateCreateClick;
exports.trackSocialCreateShow = trackSocialCreateShow;
exports.trackSocialMergeMergeClick = trackSocialMergeMergeClick;
exports.trackSocialMergeSucceed = trackSocialMergeSucceed;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _analytics = require("@cian/analytics");
var _tracking = require("../../utils/tracking");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function trackSocialCreateCreateClick(_ref) {
  let {
    label,
    source
  } = _ref;
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'complete_reg_popup_click',
    label
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}
function trackSocialCreateShow(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'complete_reg_popup_show'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}
function trackSocialButtonClick(type, source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'click',
    label: type
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}
function trackSocialAuthenticateEmailTaken(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'link_accounts_show'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}
function trackSocialMergeMergeClick(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'link_accounts_click'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}
function trackSocialMergeSucceed(source) {
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'Authorization',
    action: 'link_accounts_success'
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}